export * from './Table';
export * from './TableComposable';
//# sourceMappingURL=index.js.map